import React, { useState } from "react";

const CONTACT_PROJECT_ID = process.env.REACT_APP_SIGNUP_PROJECT_ID;

export default function Contact() {
  const [values, setValues] = useState({ name: "", email: "", phone: "", message: "" });
  const [status, setStatus] = useState({ message: "", error: false });
  const [submitting, setSubmitting] = useState(false);

  const setValue = (name, value) => setValues(current => ({ ...current, [name]: value }));

  async function submit(event) {
    event.preventDefault();
    setSubmitting(true);
    setStatus({ message: "", error: false });
    try {
      if (!CONTACT_PROJECT_ID) throw new Error("Contact form configuration is unavailable.");
      const body = {
        projectId: CONTACT_PROJECT_ID,
        formName: "bouncehouse-admin-contact",
        name: values.name.trim(),
        email: values.email.trim(),
        message: values.message.trim(),
        source: { campaign: "bouncehouse-admin-contact" }
      };
      if (values.phone.trim()) body.phone = values.phone.trim();

      const response = await fetch("https://go.switchbaq.com/activities", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          "x-domain": "admin.bouncehouse.com"
        },
        body: JSON.stringify(body),
        credentials: "omit"
      });
      if (!response.ok) {
        const data = await response.json().catch(() => null);
        throw new Error(data?.error || data?.message || `Submit failed (${response.status})`);
      }
      setStatus({ message: "Thanks! We’ll be in touch soon.", error: false });
      setValues({ name: "", email: "", phone: "", message: "" });
    } catch (error) {
      setStatus({ message: error?.message || "Submission failed.", error: true });
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-6">
          <div className="text-center mb-4">
            <h1 className="fw-bold mb-2">Contact us</h1>
            <p className="text-muted mb-0">Have a question? Send us a message and we’ll follow up.</p>
          </div>

          {status.message && (
            <div className={`alert ${status.error ? "alert-danger" : "alert-success"}`}>{status.message}</div>
          )}

          <div className="card shadow-sm border-0">
            <div className="card-body p-4 p-md-5">
              <form onSubmit={submit}>
                <div className="mb-3">
                  <label className="form-label">Name</label>
                  <input className="form-control" value={values.name} onChange={event => setValue("name", event.target.value)} required />
                </div>
                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input type="email" className="form-control" value={values.email} onChange={event => setValue("email", event.target.value)} required />
                </div>
                <div className="mb-3">
                  <label className="form-label">Phone (optional)</label>
                  <input type="tel" className="form-control" value={values.phone} onChange={event => setValue("phone", event.target.value)} />
                </div>
                <div className="mb-3">
                  <label className="form-label">Message</label>
                  <textarea className="form-control" rows="5" value={values.message} onChange={event => setValue("message", event.target.value)} required />
                </div>
                <button type="submit" className="btn btn-primary w-100" disabled={submitting}>
                  {submitting ? "Please wait…" : "Submit"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
